import(/* webpackMode: "eager" */ "/vercel/path0/app/[locale]/disposal/old-furniture-removal/page.tsx");
